// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__29uI7","calendarButtons":"ClockData_calendarButtons__DEuM8"};